import { nanoid } from 'nanoid/async'

import CONST_SOCKET from '../../const/socket'
import { actionButtonModal } from './actionButtonModal'
import { 
  updateNodeConnections,
  getNodeOutputConnectionsBySocketName,
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor, defaultData) => {
  const oldData = node.data
  const { value: actionButtonData } = await actionButtonModal(oldData, node, defaultData)

  if (actionButtonData && Object.values(actionButtonData).length > 0) {
    // Create messenger engagement unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, actionButtonData)
    node.update()
    updateNodeConnections(node)
    toggleStartBotFlowElementsBasedOnActionButtonData(node)
  }

  return false
}

const toggleStartBotFlowElementsBasedOnActionButtonData = (node) => {
  const connections = getNodeOutputConnectionsBySocketName(CONST_SOCKET.ACTION_BUTTON_OUTPUT, node)

  if (connections[0]) {
    const targetNode = connections[0].input.node
    const componentElement = $(targetNode.vueContext.$el)
    const targetElementModal = componentElement.find('.sequence_ids').parent()

    // const referenceOutputSequenceClass = CONST_SOCKET.REFERENCE_OUTPUT_SEQUENCE.toLowerCase()
    // const targetElementNode = componentElement.find('.' + referenceOutputSequenceClass).parent()

    if ('actionType' in node.data) {
      if (('get-started' === node.data.actionType) || ('messenger_engagement_plugin' === node.data.actionType)) {
        targetElementModal.removeClass('d-none').addClass('d-block')
      } else {
        targetElementModal.removeClass('d-block').addClass('d-none')
      }
    }
  }
}